// 'SPACE(공간 보유자)' 회원유형 — 계속 닫아 둔다. ★ 2026-11-03 공간 대관은 학원원장·강사·무용수가 호스트(서버 RequireActiveRole).
export const SPACE_FEATURE_ENABLED = false;
// ★ 2026-11-03 공간 대관 화면(목록·상세·예약·호스트 관리) 재오픈 — 서버 공간 기능이 켜졌다. 회원유형 SPACE 와 별개.
export const SPACE_RENTAL_ENABLED = true;

// ★ 2026-10-11 대타 긴급 발송 기능 종료. 등록 화면 체크·강사 알림 설정을 숨긴다(서버 common/feature-flags.ts 와 함께 바꾼다).
export const SUB_DISPATCH_ENABLED = false;
